import {Avatar, Button, Paper} from "@material-ui/core";
import React from "react";
import {DropzoneArea} from "material-ui-dropzone";
import {CameraAlt} from "@material-ui/icons";
import {formatDateUS} from "../../../../helpers/utils";
import {FamilyOfficeChip} from "../../shared/Chips";
import OtherEntitiesManager from "../../shared/OtherEntitiesManager";
import InvestorService from "../../services/InvestorService";

const InvestorDetailsSideBar = (
    { investor, avatar, handleChangeFileInput, isDeleted, onDelete, drafts=false, session, investorId, onRemoveOtherEntity, ...props }
) => {

    const last_update = drafts ? investor?.updated : investor?.latest_update

    return (
        <div className="user-details-sidebar">
            <Paper className="photo-container" elevation={3}>
                <div className='user-avatar-container'>
                    <Avatar src={avatar} className="photo" alt="user-avatar" />
                    <DropzoneArea
                        acceptedFiles={['image/*']}
                        dropzoneText={"Upload Image"}
                        Icon={CameraAlt}
                        filesLimit={1}
                        showPreviews={false}
                        showAlerts={false}
                        onDrop={(files) => handleChangeFileInput(files)}
                        styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
                    />
                </div>

                <div className="contact-details" >
                    <div className="info-item">
                        <span>Name</span>
                        <span>{!!investor?.id ? investor.name : '-'}</span>
                    </div>
                    <div className="info-item">
                        <span>Company Email</span>
                        <span>{investor?.company_email ?? '-'}</span>
                    </div>
                    <div className="info-item">
                        <span>Researcher</span>
                        <span>
                            {investor?.researcher_name ?? '-' }
                        </span>
                    </div>
                    <div className="info-item">
                        <span>Family Office Type</span>
                        <span>
                            { !!investor?.id ? (<FamilyOfficeChip type={investor.family_office_type}/>) : '-' }
                        </span>
                    </div>
                    <OtherEntitiesManager
                        ownerName={investor?.name}
                        entities={investor?.other_entities}
                        canRemove={(e) => e.entity_type === 'RIA'}
                        onRemove={async (e) => {
                            if (!investorId || !session) return true;
                            const res = await InvestorService.removeOtherEntity(investorId, session, e.entity_type);
                            if (res?.data?.status === 'success') {
                                onRemoveOtherEntity?.(res.data.other_entities, res.data.crd_id);
                                return (res.data.other_entities || []).length > 0;
                            }
                            return true;
                        }}
                    />
                    <div className="info-item">
                        <span>Created</span>
                        <span>{ !!investor?.id ? formatDateUS(investor?.created) : '-' }</span>
                    </div>
                    <div className="info-item">
                        <span>Latest Update</span>
                        <span>{ !!investor?.id ? formatDateUS(last_update) : '-' }</span>
                    </div>
                    {investor?.last_pm_update ? <div className="info-item">
                        <span>Last PM Update</span>
                        <span>{ !!investor?.id && investor?.last_pm_update ? formatDateUS(investor?.last_pm_update) : '-' }</span>
                    </div> : null }
                    {
                        !!investor?.id && <div className="info-item">
                            <Button variant="contained" onClick={onDelete} className="error">
                                Archive
                            </Button>
                        </div>
                    }
                </div>
            </Paper>
        </div>
    );
}

const otherEntitiesKey = (entities) =>
    (entities || []).map(e => `${e.entity_type}-${e.entity_id}`).join(',');

export default React.memo(InvestorDetailsSideBar, (prevProps, nextProps) => {
    return ( prevProps.investor?.id === nextProps.investor?.id ) &&
           (prevProps.avatar === nextProps.avatar) &&
           (prevProps.investor?.last_reviewed === nextProps.investor?.last_reviewed) &&
           (otherEntitiesKey(prevProps.investor?.other_entities) === otherEntitiesKey(nextProps.investor?.other_entities))
});
